import { memo } from 'react'
import { useIntl } from 'react-intl'
import { Flex, Space } from 'antd'
import Button from '../../../../common/Button'
import EllipsisTooltip from '../../../../common/EllipsisTooltip'

const SelectedRecordCard = ({ record, onClear }) => {
  const intl = useIntl()
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      className="selected-connector"
      data-testid="fd-selected-record"
    >
      <Space direction="vertical" size={0}>
        <EllipsisTooltip className='ellipsis'>
          <span className="bolder">{record?.name}</span>
        </EllipsisTooltip>
        <EllipsisTooltip className='ellipsis'>
          <span>{record?.description}</span>
        </EllipsisTooltip>
      </Space>
      <Button type="link" className="link-button" onClick={onClear} testId="fd-selected-clear" style={{marginLeft: 5}}>
        {intl.formatMessage({ id: 'functionalDiagram.clear' })}
      </Button>
    </Flex>
  )
}

export default memo(SelectedRecordCard)
